import {
  IEntity,
  IEntityCreate,
  IEntityDropDown,
  IEntityTable,
  IPagedData,
  IPagedSearch,
  ISelectItem,
  TableStatus,
} from '@evencel/models';
import { Selectable } from '@evencel/ui';

export class GetEntity {
  public static readonly type = '[Entity] GetEntity';
  constructor(public id: string) {}
}

export class ActivateEntity {
  public static readonly type = '[Entity] ActivateEntity';
  constructor(public entity: IEntityTable) {}
}

export class SearchEntitys {
  public static readonly type = '[Entity] SearchEntitys';
  constructor(public data: IPagedSearch) {}
}

export class CreateEntity {
  public static readonly type = '[Entity] SaveEntity';
  constructor(public entity: IEntityCreate) {}
}

export class UpdateEntity {
  public static readonly type = '[Entity] UpdateEntity';
  constructor(public entity: IEntity) {}
}

export class DeleteEntity {
  public static readonly type = '[Entity] DeleteEntity';
  constructor(public entity: IEntityTable) {}
}

export class RestoreEntity {
  public static readonly type = '[Entity] RestoreEntity';
  constructor(public entity: IEntityTable) {}
}

export class GetEntitysResponse {
  public static readonly type = '[Entity] GetEntitysResponse';
  constructor(
    public pagedData: IPagedData<IEntity>,
    public status: TableStatus
  ) {}
}

export class EntityTypeSelected extends Selectable<ISelectItem> {
  public static readonly type = '[Entity] EntityTypeSelected';
  constructor(
    public override item: ISelectItem,
    public override durty = false
  ) {
    super(item);
  }
}
export class EntityTypeDeselect extends Selectable<ISelectItem> {
  public static readonly type = '[Entity] EntityTypeDeselect';
  constructor(public override item: ISelectItem) {
    super(item);
  }
}

export class EntityRelationshiptToCenterSelected extends Selectable<ISelectItem> {
  public static readonly type = '[Entity] EntityRelationshiptToCenterSelected';
  constructor(
    public override item: ISelectItem,
    public override durty = false
  ) {
    super(item);
  }
}
export class EntityRelationshiptToCenterDeselected extends Selectable<ISelectItem> {
  public static readonly type =
    '[Entity] EntityRelationshiptToCenterDeselected';
  constructor(public override item: ISelectItem) {
    super(item);
  }
}

export class GetEntityResponse {
  public static readonly type = '[Entity] GetEntityResponse';
  constructor(public entity: IEntity) {}
}

export class GetEntityDropDown {
  public static readonly type = '[Entity] GetEntityDropDown';
}

export class GetEntityDropDownResponse {
  public static readonly type = '[Entity] GetEntityDropDownResponse';
  constructor(public entity: IEntityDropDown) {}
}
